import styled from 'styled-components';

const MediaChannelStyled = styled.div`
  display: flex;
  flex-direction: column;
  
  .mediaChannelSelector {
    &__content {
      min-height: 212px;
    }

    &__cardContainer {
      display: flex;
      gap: var(--spacing-16);
      justify-content: center;
    }

    &__cardMedia {
      min-height: 88px;
      background-color: var(--color-sonata-primary-300) !important;
      
      .cardMedia__icon {
        color: var(--color-sonata-li-primary-white);
      }

      &--selected {
        background: var(--color-sonata-interaction-400, #FF8E71) !important;
      }
    }

    &__cardDescription {
      display: block;
      text-align: center;
    }

    &__infoCard {
      width: 212px;
      padding: var(--spacing-10) var(--spacing-10) var(--spacing-16) var(--spacing-10);
    }

    &__header {
      display: flex;
      flex-direction: column;
      padding-bottom: 24px;
      align-items: center;

      &Title {
        color: var(--color-sonata-primary-700, #283D60);
        font: var(--font-body-600-bold);
      }
      
      &Icon {
        color: var(--color-sonata-primary-500, #7B9FE1);
        padding-bottom: var(--spacing-32);
      }

      &SubTitle {
        color: var(--color-sonata-primary-700, #283D60);;
        font: var(--font-body-600-regular);
      }
    }
  }
`;

export { MediaChannelStyled };
